/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrchestratorAdminJobUpdateRequest { 
    state?: OrchestratorAdminJobUpdateRequest.StateEnum | null;
    priority?: number | null;
    reprocess?: boolean | null;
    machine_id?: string | null;
    preferred_machine?: string | null;
    prefer_deadline?: string | null;
    s3_path?: string | null;
}
export namespace OrchestratorAdminJobUpdateRequest {
    export const StateEnum = {
        Pending: 'PENDING',
        Processing: 'PROCESSING',
        Completed: 'COMPLETED',
        Error: 'ERROR',
        Cancelled: 'CANCELLED'
    } as const;
    export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
}


